addEventListener('DOMContentLoaded', () => {
	const header = document.body.querySelector('header')
	const hamburgerButton = header.querySelector('button.hamburger-toggle')

	hamburgerButton.addEventListener('click', function () {
		document.body.classList.toggle('open')
		header.scrollIntoView?.({
			behavior: 'smooth',
			block: 'start',
			inline: 'start',
		})
	})
})